import { getAdminText } from "./adminSozluk";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { collection, doc, getDocs, updateDoc } from "firebase/firestore";
import { somerenAccessDb } from "../access/somerenAccessFirebase";

// DISC katılımcı linkleri — /linkler
// 2026-08-16: daha önce bu liste yalnız yerel bir HTML dosyasıydı (localhost:5299)
// ve "kime verildi" alanı hiçbir yere kaydolmuyordu. Artık canlı sayfa:
//   · kodlar somerenlabs0/accessCodes'tan okunur
//   · "kime verildi" doğrudan accessCodes/<KOD>.assignedTo alanına yazılır
//   · her kodun durumu (açık / kullanıldı + tamamlayan) görünür
//
// KAPSAM: yalnız DISC kodları. Diğer envanterler için ayrı sayfa yapılacak.
//
// KAPI HAKKINDA DÜRÜST NOT: buradaki şifre, mevcut Admin Paneli ile AYNI seviyede —
// yani yalnız tarayıcıda karşılaştırılıyor. Gerçek sınır değil, kaza/merak engeli.
// Sunucu tarafı koruma için somerenlabs0 kurallarının sıkılaştırılması gerekir
// (accessCodes şu an kimliksiz okunup yazılabiliyor).
const SAYFA_SIFRESI = "ajl6138";

// ARAYÜZ DİLİ ≠ LİNK DİLİ.
//   arayüz dili → bu sayfanın kendi metinleri (aşağıdaki `arayuzDili`)
//   link dili   → katılımcının açacağı envanterin dili (`dil` durumu)
// İkisi bilerek ayrıdır: Türkçe konuşan temsilci İngilizce link üretebilir.
// Başlangıç değeri ?slLang parametresinden okunur (sistemin geri kalanıyla aynı).
function baslangicArayuzDili() {
  try {
    const p = new URLSearchParams(window.location.search);
    return String(p.get("slLang") || "").trim().toLowerCase() === "en" ? "en" : "tr";
  } catch {
    return "tr";
  }
}
const URUN = "DISC";
const TABAN = "https://somerenlabs-inv2.web.app/";

export default function LinklerSayfasi() {
  const [arayuzDili, setArayuzDili] = useState(baslangicArayuzDili);
  const A = getAdminText(arayuzDili);
  const [girisVar, setGirisVar] = useState(false);
  const [sifre, setSifre] = useState("");
  const [sifreHatasi, setSifreHatasi] = useState("");

  const [kodlar, setKodlar] = useState([]);
  const [yukleniyor, setYukleniyor] = useState(false);
  const [hata, setHata] = useState("");
  const [sirket, setSirket] = useState("hepsi");
  const [dil, setDil] = useState("tr");
  const [kayitDurumu, setKayitDurumu] = useState({}); // kod -> "yaziliyor" | "ok" | "hata"
  const [kopyalanan, setKopyalanan] = useState("");

  const yukle = useCallback(async () => {
    setYukleniyor(true);
    setHata("");
    try {
      const snap = await getDocs(collection(somerenAccessDb, "accessCodes"));
      const hepsi = [];
      snap.forEach((d) => hepsi.push({ id: d.id, ...d.data() }));

      // Yalnız DISC için üretilmiş bireysel katılımcı kodları
      const discKodlari = hepsi
        .filter(
          (k) =>
            k.type === "participant-single-use" &&
            String(k.inventoryKey || "").toUpperCase() === URUN
        )
        .sort((a, b) => a.id.localeCompare(b.id, "tr"));

      // Paketlerin kalan DISC kotasını da göstermek için eşle
      const paketler = Object.fromEntries(
        hepsi.filter((k) => k.productRights).map((k) => [k.id, k])
      );

      setKodlar(
        discKodlari.map((k) => {
          const paket = paketler[k.parentPackageCode] || null;
          const hak = paket?.productRights?.[URUN] || null;
          return {
            ...k,
            paketKalan: hak ? Number(hak.remainingUses ?? hak.remainingRooms ?? 0) : null,
            paketToplam: hak ? Number(hak.totalUses ?? hak.totalRooms ?? 0) : null,
          };
        })
      );
    } catch (e) {
      console.error("kodlar okunamadı", e);
      setHata(A.lnkKodlarOkunamadi);
    } finally {
      setYukleniyor(false);
    }
    // A.lnkKodlarOkunamadi bağımlılıkta: arayüz dili değişince hata metni de değişmeli.
  }, [A.lnkKodlarOkunamadi]);

  useEffect(() => {
    if (girisVar) yukle();
  }, [girisVar, yukle]);

  const sirketler = useMemo(() => {
    const m = new Map();
    kodlar.forEach((k) => {
      const anahtar = k.companyId || k.companyName || "—";
      if (!m.has(anahtar)) m.set(anahtar, k.companyName || k.companyId || "—");
    });
    return [...m.entries()].sort((a, b) => a[1].localeCompare(b[1], "tr"));
  }, [kodlar]);

  const gorunen = useMemo(
    () =>
      sirket === "hepsi"
        ? kodlar
        : kodlar.filter((k) => (k.companyId || k.companyName || "—") === sirket),
    [kodlar, sirket]
  );

  const ozet = useMemo(() => {
    const kullanilan = gorunen.filter((k) => k.status === "completed").length;
    return { toplam: gorunen.length, kullanilan, acik: gorunen.length - kullanilan };
  }, [gorunen]);

  function linkYap(kod) {
    return `${TABAN}?slAccessCode=${kod}&slInventory=${URUN}&slLang=${dil}`;
  }

  async function kimeVerildiKaydet(kod, deger) {
    setKayitDurumu((d) => ({ ...d, [kod]: "yaziliyor" }));
    try {
      await updateDoc(doc(somerenAccessDb, "accessCodes", kod), {
        assignedTo: deger,
        assignedAt: new Date().toISOString(),
      });
      setKayitDurumu((d) => ({ ...d, [kod]: "ok" }));
      setTimeout(() => setKayitDurumu((d) => ({ ...d, [kod]: "" })), 4000);
      return true;
    } catch (e) {
      console.error("kaydedilemedi", e);
      setKayitDurumu((d) => ({ ...d, [kod]: "hata" }));
      return false;
    }
  }

  function kopyala(metin, kod) {
    const bitir = () => {
      setKopyalanan(kod);
      setTimeout(() => setKopyalanan(""), 1500);
    };
    try {
      const ta = document.createElement("textarea");
      ta.value = metin;
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.select();
      const ok = document.execCommand("copy");
      document.body.removeChild(ta);
      if (ok) return bitir();
    } catch (e) {}
    if (navigator.clipboard) navigator.clipboard.writeText(metin).then(bitir);
  }

  if (!girisVar) {
    return (
      <div style={s.kapiSar}>
        <form
          style={s.kapiKart}
          onSubmit={(e) => {
            e.preventDefault();
            if (sifre === SAYFA_SIFRESI) {
              setGirisVar(true);
              setSifreHatasi("");
            } else {
              setSifreHatasi(A.lnkHataliSifre);
            }
          }}
        >
          <p style={s.kapiUst}>SOMEREN LABS · DISC</p>
          <h1 style={s.kapiBaslik}>{A.lnkBaslik}</h1>
          <p style={s.kapiAlt}>{A.lnkAltBaslik}</p>
          <input
            type="password"
            autoFocus
            value={sifre}
            onChange={(e) => setSifre(e.target.value)}
            placeholder={A.lnkSifre}
            style={s.kapiGirdi}
          />
          {sifreHatasi ? <div style={s.kapiHata}>{sifreHatasi}</div> : null}
          <button type="submit" style={s.kapiDugme}>{A.lnkAc}</button>
        </form>
      </div>
    );
  }

  return (
    <div style={s.sar}>
      <div style={s.kutu}>
        <div style={s.baslikSatiri}>
          <div>
            <p style={s.ust}>SOMEREN LABS · DISC</p>
            <h1 style={s.baslik}>{A.lnkLinkler}</h1>
          </div>
          <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
            {/* ARAYÜZ dili — aşağıdaki "Link dili" ile karıştırılmamalı */}
            <label style={{ fontSize: 12, color: "#6b7280", display: "flex", gap: 6, alignItems: "center" }}>
              {A.lnkArayuzDili}
              <select
                value={arayuzDili}
                onChange={(e) => setArayuzDili(e.target.value)}
                style={{ fontSize: 12, padding: "4px 6px", borderRadius: 6, border: "1px solid #d1d5db" }}
              >
                <option value="tr">TR</option>
                <option value="en">EN</option>
              </select>
            </label>
            <button type="button" onClick={yukle} style={s.yenile} disabled={yukleniyor}>
              {yukleniyor ? A.lnkYukleniyor : A.lnkYenile}
            </button>
          </div>
        </div>

        <div style={s.filtreler}>
          <label style={s.etiket}>
            {A.lnkSirket}
            <select value={sirket} onChange={(e) => setSirket(e.target.value)} style={s.secim}>
              <option value="hepsi">{A.lnkTumu(kodlar.length)}</option>
              {sirketler.map(([anahtar, ad]) => (
                <option key={anahtar} value={anahtar}>
                  {ad} ({kodlar.filter((k) => (k.companyId || k.companyName || "—") === anahtar).length})
                </option>
              ))}
            </select>
          </label>

          <label style={s.etiket}>
            {A.lnkLinkDili}
            <select value={dil} onChange={(e) => setDil(e.target.value)} style={s.secim}>
              <option value="tr">{A.lnkDilTr}</option>
              <option value="en">{A.lnkDilEn}</option>
            </select>
          </label>

          <span style={s.ipucu}>{A.lnkIpucuOnce}<b>Enter</b>{A.lnkIpucuSonra}</span>
          <span style={s.ozet}>
            {ozet.toplam} kod · <b style={{ color: "#047857" }}>{ozet.acik} açık</b> ·{" "}
            <b style={{ color: "#b91c1c" }}>{ozet.kullanilan} kullanıldı</b>
          </span>
        </div>

        {hata ? <div style={s.hataKutu}>{hata}</div> : null}

        {!yukleniyor && !gorunen.length ? (
          <p style={s.bos}>{A.lnkKodYok}</p>
        ) : null}

        {gorunen.length ? (
          <div style={s.tabloKutu}>
            <table style={s.tablo}>
              <thead>
                <tr>
                  <th style={s.th}>{A.lnkKod}</th>
                  <th style={s.th}>{A.lnkSirket}</th>
                  <th style={s.th}>{A.lnkLink}</th>
                  <th style={s.th}></th>
                  <th style={s.th}>{A.lnkKimeVerildi}</th>
                  <th style={s.th}>{A.lnkDurum}</th>
                </tr>
              </thead>
              <tbody>
                {gorunen.map((k) => (
                  <Satir
                    key={k.id}
                    kod={k}
                    link={linkYap(k.id)}
                    durum={kayitDurumu[k.id]}
                    kopyalandi={kopyalanan === k.id}
                    onKaydet={kimeVerildiKaydet}
                    onKopyala={kopyala}
                    A={A}
                  />
                ))}
              </tbody>
            </table>
          </div>
        ) : null}

        <div style={s.not}>
          {A.lnkNot1}<br />
          {A.lnkNot2Once}<b>{A.lnkHarcanmaz}</b>{A.lnkHarcanmazDevam}<br />
          {A.lnkNot3}<code>assignedTo</code>{A.lnkNot3Son}
        </div>
      </div>
    </div>
  );
}

function Satir({ kod, link, durum, kopyalandi, onKaydet, onKopyala, A }) {
  const [ad, setAd] = useState(kod.assignedTo || "");
  // 2026-08-16: "kaydedilmedi" uyarısı KAYITTAN SONRA da duruyordu, çünkü karşılaştırma
  // listeden gelen (bayat) `kod.assignedTo` ile yapılıyordu; o değer ancak sayfa
  // yenilenince tazeleniyor. Sonuç: kayıt BAŞARILI olmasına rağmen ekran
  // "kaydedilmedi" diyordu — kullanıcıyı haklı olarak tereddüde düşüren şey buydu.
  // Artık en son BAŞARIYLA yazılan değer satırın kendi durumunda tutuluyor.
  const [kayitliDeger, setKayitliDeger] = useState(kod.assignedTo || "");
  useEffect(() => {
    setAd(kod.assignedTo || "");
    setKayitliDeger(kod.assignedTo || "");
  }, [kod.assignedTo]);

  const kullanildi = kod.status === "completed";
  const kisaKod = kod.id.replace(/^.*-DISC-/, "");
  const bekleyen = kayitliDeger !== ad.trim();

  async function kaydet() {
    const yeni = ad.trim();
    if (kayitliDeger === yeni) return;                 // değişmediyse yazma
    const oldu = await onKaydet(kod.id, yeni);
    if (oldu) setKayitliDeger(yeni);                   // ancak BAŞARIDA "kaydedildi" say
  }

  return (
    <tr>
      <td style={s.td}>
        <span style={s.kodMetni} title={kod.id}>{kisaKod}</span>
      </td>
      <td style={{ ...s.td, ...s.sirketHucre }}>{kod.companyName || kod.companyId || "—"}</td>
      <td style={s.td}>
        <input readOnly value={link} style={s.linkGirdi} onFocus={(e) => e.target.select()} />
      </td>
      <td style={s.td}>
        <button
          type="button"
          onClick={() => onKopyala(link, kod.id)}
          style={{ ...s.kopyalaDugme, ...(kopyalandi ? s.kopyalandi : null) }}
        >
          {kopyalandi ? A.lnkKopyalandi : "Kopyala"}
        </button>
      </td>
      <td style={s.td}>
        {/* 2026-08-16: ENTER ARTIK KAYDEDİYOR. Önce yalnız `onBlur` vardı; kullanıcı
            yazıp Enter'a bastı, hiçbir şey olmadı sandı — oysa kayıt ancak başka bir
            yere tıklayınca oluyordu. Üstelik geri bildirim 1,8 sn'lik soluk bir çerçeve
            olduğu için görülmüyordu. Artık: Enter kaydeder, durum YAZIYLA görünür ve
            4 sn kalır; kaydedilmemiş değişiklik varken de uyarı yazar. */}
        <input
          value={ad}
          onChange={(e) => setAd(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              kaydet();
              e.currentTarget.blur();
            }
          }}
          onBlur={kaydet}
          placeholder="kime verildi?"
          style={{
            ...s.adGirdi,
            ...(durum === "ok" ? s.adKayitli : null),
            ...(durum === "yaziliyor" ? s.adYaziliyor : null),
            ...(durum === "hata" ? s.adHata : null),
            ...(bekleyen ? s.adBekleyen : null),
          }}
        />
        <span style={{ ...s.kayitNotu, ...(durum === "hata" ? s.kayitNotuHata : null) }}>
          {durum === "yaziliyor"
            ? A.lnkKaydediliyor
            : durum === "ok"
            ? A.lnkKaydedildi
            : durum === "hata"
            ? A.lnkKaydedilemedi
            : bekleyen
            ? A.lnkKaydedilmedi
            : ""}
        </span>
      </td>
      <td style={s.td}>
        <span style={{ ...s.rozet, ...(kullanildi ? s.rozetKullanildi : s.rozetAcik) }}>
          {kullanildi ? A.lnkKullanildi : A.lnkAcik}
        </span>
        {kullanildi && kod.participantName ? (
          <span style={s.altNot}>tamamlayan: {kod.participantName}</span>
        ) : null}
      </td>
    </tr>
  );
}

const s = {
  sar: { minHeight: "100vh", background: "#f7f9fc", padding: "28px 20px 60px",
    font: '15px/1.5 -apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif', color: "#1d3557" },
  kutu: { maxWidth: 1180, margin: "0 auto", background: "#fff", border: "1px solid #e2e8f0",
    borderRadius: 14, padding: "24px 26px" },
  baslikSatiri: { display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 12, flexWrap: "wrap" },
  ust: { margin: 0, fontSize: 11, letterSpacing: "0.14em", fontWeight: 800, color: "#64748b" },
  baslik: { margin: "4px 0 0", fontSize: 22, color: "#1d3557" },
  yenile: { padding: "8px 16px", border: "1px solid #e2e8f0", background: "#fff", color: "#1d3557",
    borderRadius: 8, cursor: "pointer", fontSize: 13 },
  filtreler: { display: "flex", gap: 18, alignItems: "flex-end", flexWrap: "wrap", margin: "18px 0 14px" },
  etiket: { display: "grid", gap: 4, fontSize: 12, color: "#64748b", fontWeight: 700 },
  secim: { padding: "7px 10px", border: "1px solid #e2e8f0", borderRadius: 8, fontSize: 14,
    color: "#1d3557", background: "#fff", minWidth: 190 },
  ozet: { fontSize: 13, color: "#64748b", paddingBottom: 7 },
  ipucu: { fontSize: 12.5, color: "#64748b", paddingBottom: 7 },
  tabloKutu: { overflowX: "auto", border: "1px solid #eef2f7", borderRadius: 10 },
  tablo: { width: "100%", borderCollapse: "collapse" },
  th: { textAlign: "left", fontSize: 11, letterSpacing: ".5px", textTransform: "uppercase",
    color: "#64748b", borderBottom: "1px solid #e2e8f0", padding: "10px 10px", whiteSpace: "nowrap" },
  td: { padding: "8px 10px", borderBottom: "1px solid #f1f5f9", verticalAlign: "middle" },
  kodMetni: { fontFamily: "ui-monospace,Menlo,monospace", fontSize: 13, whiteSpace: "nowrap", fontWeight: 700 },
  sirketHucre: { fontSize: 13, color: "#475569", whiteSpace: "nowrap" },
  linkGirdi: { width: "100%", minWidth: 260, padding: "6px 9px", border: "1px solid #e2e8f0",
    borderRadius: 7, font: "12px ui-monospace,Menlo,monospace", color: "#64748b", background: "#fbfdff" },
  kopyalaDugme: { padding: "7px 14px", border: "none", borderRadius: 7, background: "#1d3557",
    color: "#fff", cursor: "pointer", fontSize: 13, whiteSpace: "nowrap" },
  kopyalandi: { background: "#2a9d8f" },
  adGirdi: { width: 172, padding: "7px 9px", border: "1px solid #e2e8f0", borderRadius: 7,
    fontSize: 13, color: "#1d3557", background: "#fff" },
  adKayitli: { borderColor: "#2a9d8f", background: "#f0fdfa" },
  adYaziliyor: { borderColor: "#fbbf24", background: "#fffbeb" },
  adHata: { borderColor: "#dc2626", background: "#fef2f2" },
  adBekleyen: { borderColor: "#f59e0b" },
  kayitNotu: { display: "block", marginTop: 3, fontSize: 11, color: "#2a9d8f", minHeight: 14, fontWeight: 700 },
  kayitNotuHata: { color: "#b91c1c" },
  rozet: { display: "inline-block", padding: "3px 9px", borderRadius: 999, fontSize: 11.5, fontWeight: 700, whiteSpace: "nowrap" },
  rozetAcik: { background: "#ecfdf5", color: "#047857" },
  rozetKullanildi: { background: "#fef2f2", color: "#b91c1c" },
  altNot: { display: "block", marginTop: 3, color: "#64748b", fontSize: 11, lineHeight: 1.3 },
  not: { marginTop: 20, paddingTop: 14, borderTop: "1px solid #e2e8f0", color: "#64748b", fontSize: 13 },
  bos: { color: "#64748b", fontSize: 14, padding: "18px 2px" },
  hataKutu: { background: "#fef2f2", color: "#b91c1c", padding: "10px 12px", borderRadius: 8,
    fontSize: 13, marginBottom: 12 },
  kapiSar: { minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
    background: "#f7f9fc", padding: 20, font: '15px/1.5 -apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif' },
  kapiKart: { width: "100%", maxWidth: 380, background: "#fff", border: "1px solid #e2e8f0",
    borderRadius: 14, padding: "26px 24px" },
  kapiUst: { margin: 0, fontSize: 11, letterSpacing: "0.14em", fontWeight: 800, color: "#64748b" },
  kapiBaslik: { margin: "6px 0 6px", fontSize: 21, color: "#1d3557" },
  kapiAlt: { margin: "0 0 16px", fontSize: 13.5, color: "#64748b" },
  kapiGirdi: { width: "100%", boxSizing: "border-box", padding: "10px 12px", border: "1px solid #e2e8f0",
    borderRadius: 9, fontSize: 15, color: "#1d3557" },
  kapiHata: { marginTop: 9, background: "#fef2f2", color: "#b91c1c", padding: "8px 10px",
    borderRadius: 7, fontSize: 13 },
  kapiDugme: { marginTop: 14, width: "100%", padding: "11px 14px", border: "none", borderRadius: 999,
    background: "#1d3557", color: "#fff", fontWeight: 800, fontSize: 15, cursor: "pointer" },
};
